<template>
  <div class="cooperativePartner">
    <div class="page-name">
      服务客户
    </div>
    <div class="brand-logo">
      <div v-for="item in imgList" :key="item">
        <img :src="item.img"/>
        <span class="name-text" :class="{'special-name': item.special}">{{item.name}}</span>
      </div>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
import brand1 from '../../assets/homePage/Group116.png'
import brand2 from '../../assets/homePage/Group117.png'
import brand3 from '../../assets/homePage/Group118.png'
import brand4 from '../../assets/homePage/Group119.png'
import brand5 from '../../assets/homePage/Group120.png'
import brand6 from '../../assets/homePage/Group121.png'
import brand7 from '../../assets/homePage/Group122.png'
import brand8 from '../../assets/homePage/Group123.png'
import brand9 from '../../assets/homePage/Group124.png'
import brand10 from '../../assets/homePage/Group125.png'
import brand11 from '../../assets/homePage/Group126.png'
import brand12 from '../../assets/homePage/Group127.png'

export default {
  name:'cooperativePartner',
  data() {
    return {
      imgList: [
      { img: brand1, name: '日本爱发科真空设备（沈阳）有限公司'},
      { img: brand2, name: '韩国明进精工机械零件（沈阳）有限公司' },
      { img: brand3, name: '沈阳博林特电梯股份有限公司' },
      { img: brand4, name: '中国平安财产保险股份有限公司辽宁分公司' },
      { img: brand5, name: '中国人民财产保险股份有限公司沈阳分公司' },
      { img: brand6, name: '中国大地保险股份有限公司辽宁分公司' },
      { img: brand7, name: '沈阳大洋电气有限公司' },
      { img: brand8, name: '海南金盘电气有限公司' },
      { img: brand9, name: '中国建设银行股份有限公司沈阳分行' },
      { img: brand10, name: '中国民生银行股份有限公司沈阳分行 ' },
      { img: brand11, name: '上海浦东发展银行股份有限公司沈阳分行、方园支行',special:true},
      { img: brand12, name: '深圳前海微众银行股份有限公司' },
      ]
    };
  },
  methods: {
  }
};
</script>

<style lang="scss">
.cooperativePartner {
  width: 100%;
  height: 100vh;
  padding: 10vh 10vw;
  box-sizing: border-box;

  .page-name {
    width: 224px;
    height: 78px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 56px;
    color: #333333;
    line-height: 66px;
    text-align: left;
  }

  .brand-logo {
    height: calc(100% - 78px - 83px);
    margin-top: 83px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between; /* 控制对齐 */

  }

  .brand-logo div {
    width: 24%; /* 每个品牌占25%的宽度 */
    display: flex;
    justify-content: center; /* 图片居中 */
    box-sizing: border-box;
    margin-bottom: 24px;
    position: relative;
  }

  img {
    max-width: 100%; /* 确保图片自适应容器 */
    height: 98%;
  }

  .name-text{
    position: absolute;
    bottom: 24px;
    color: #666666;
    font-size: 14px;
    width: 270px; /* 设置固定宽度，使文字可折行 */
    text-align: center; /* 文字水平居中 */
    white-space: normal; /* 允许文字换行（默认其实就是normal，可显式强调） */
  }

  .special-name{
    bottom: 10px;
  }
}
</style>
